import type { Image } from '../types';

/* Was `mapImpagesToNavigationCardInfoObjects` in ImageMapper.ts. Same counts, but the return
   type now declares every field the filmstrip card actually reads. The old
   `NavigationCardInfo` omitted five of them (movable, laksvelScores, skottelus,
   adult_female_lice, chilean_female_lice) and type-checked only because the container held
   the result in a `useState([])`, i.e. `never[]`. */

export interface FilmstripBadges {
    healing: number;
    active: number;
    movable: number;
    skottelus: number;
    adult_female_lice: number;
    chilean_female_lice: number;
    /** Empty for an image without a laksvel score, which the card would otherwise split. */
    laksvelScores: NonNullable<Image['score']>[];
    daysOld: number;
    imageId: string;
    path: string;
}

const MILLISECONDS_PER_DAY = 86_400_000;

function countTag(image: Image, tag: string) {
    return image.bboxes?.filter((box) => box.tag === tag).length ?? 0;
}

export function mapImagesToFilmstripBadges(images: Image[]): FilmstripBadges[] {
    return images.map((image) => ({
        healing: countTag(image, 'healing_wound'),
        active: countTag(image, 'wound'),
        // A `two_movables` box is one detection covering two lice, so it counts twice.
        movable: countTag(image, 'movable') + countTag(image, 'two_movables') * 2,
        skottelus: countTag(image, 'skottelus') + countTag(image, 'skottelus_2'),
        adult_female_lice: countTag(image, 'adult_female_lice'),
        chilean_female_lice: countTag(image, 'chilean_female_lice'),
        laksvelScores: image.score ? [image.score] : [],
        daysOld: image.timeStamp
            ? Math.floor((Date.now() - Date.parse(image.timeStamp)) / MILLISECONDS_PER_DAY)
            : 0,
        imageId: image.id,
        path: image.path,
    }));
}
